export const media = {
    phone: 320,
    tablet: 768,
    laptop: 1024,
    laptopL: 1600,
    fullHD: 1920
};
